export default "__VITE_ASSET__d600c74b__"